import { Component, Input, Output, EventEmitter } from "@angular/core"

@Component({
    selector: "app-role-selector",
    templateUrl: "./role-selector.component.html",
    styleUrls: ["./role-selector.component.less"],
})
export class RoleSelectorComponent {
    @Input() items: Array<any>
    @Input() selectedItem: any
    @Output() selectedItemChange = new EventEmitter<any>()
}
